import React, { useEffect, useRef, useState } from 'react';
import { FiMinus, FiPlus } from 'react-icons/fi';

import getFullDimensions from '../../../utils/getFullDimensions';

const ToggleItem = ({ item, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [height, setHeight] = useState();
  const [baseHeight, setBaseHeight] = useState();

  const containerRef = useRef();

  useEffect(() => {
    if (containerRef.current) {
      const { paddingTop, paddingBottom } = getFullDimensions(
        containerRef.current,
      );
      const button = containerRef.current.querySelector('button');
      const { height: buttonHeight } = getFullDimensions(button);
      const newBaseHeight = buttonHeight + paddingBottom + paddingTop;
      setBaseHeight(newBaseHeight);

      const paragraph = containerRef.current.querySelector('p');
      const { height: paragraphHeight } = getFullDimensions(paragraph);
      setHeight(paragraphHeight + newBaseHeight);
    }
  }, [containerRef]);

  function handleClick() {
    setIsOpen(!isOpen);
  }

  return (
    <div
      className="border-t border-gray-100 py-6"
      ref={containerRef}
      style={{
        height: isOpen ? `${height}px` : `${baseHeight}px`,
        transition: 'height .3s',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={handleClick}
        className="flex justify-between items-center w-full text-left focus:outline-none hover:opacity-80 font-medium text-black font-inter"
        aria-label={item.question}
      >
        <h3 className="text-xl tracking-tightest font-inter font-semibold lg:text-2xl">
          {item.question}
        </h3>

        <div className="text-gray-300 text-xl">
          {!isOpen && <FiPlus />}
          {isOpen && <FiMinus />}
        </div>
      </button>
      <p className="mt-6 leading-relaxed">{item.answer}</p>
    </div>
  );
};

export default ToggleItem;
